import { Component, Input, OnInit } from '@angular/core';
import { Benefit } from 'src/app/interfaces/benefit/benefit.interface';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { SliderService } from 'src/app/services/api/sliders/slider.service';

@Component({
  selector: 'app-points-historic',
  templateUrl: './points-historic.component.html',
  styleUrls: ['./points-historic.component.scss']
})
export class PointsHistoricComponent implements OnInit {

  movements: any = [];
  currentUser: any;
  slidersBenefit? : any = [];
  loading: boolean = true;
  isMobile: boolean = window.innerWidth <= 1000;
  @Input() modifyTitle: string = '';
  imageSrc = this.isMobile ? '../../../assets/icon/icon-shell-box-mobile.svg' : '../../../assets/icon/icon-shell-box.svg';
  userName: string;
  benefits: any;

  constructor(
    private benefitsService: BenefitsService,
    private sliderService: SliderService,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
    this.getBenefits();
    this.handleUser();
    this.getSliderBenefits();
    let tthis = this;
    this.benefitsService.getMovements()
    .toPromise()
    .then((res: any) => {
      tthis.movements = (res.movements)?res.movements.reverse():res.movements;
      tthis.movements.forEach((el: any) => {
        el.date = new Date(el.date);
        el.date.toLocaleString();
      })
      tthis.loading = false;
    })
  }

  getImageForDescription(description1: string, description2: string): string  {

    if (description1 === 'Transferencia de Puntos') {
      return '../../../assets/icon/icon-exchange-transfer-yellow.svg';
    }
  
    if (description2 === 'Transferencia enviada') {
      return '../../../assets/icon/icon-exchange-transfer-red.svg';
    }

    if (description1 === 'Conversor' || description1 === 'Sorteo' || description1 === 'Conversor Cencosud' || description1 === 'Checkout') {
      return '../../../assets/icon/icon-exchange.svg';
    }
  
    if ([
      'Combustible Super',
      'Combustible V Power',
      'Combustible V Power Lunes',
      'Combustible V Power Empleados',
      'Combustible V Power Jumbo Prime',
      'Combustible Super Empleados',
      'Carga por transacción'
    ].includes(description1)) {
      return '../../../assets/icon/icon-charge-yellow.svg';
    }
  
    if (description1 === 'Tienda Select') {
      return '../../../assets/icon/Icon-shell-select-yellow-rounded.svg';
    }
  
    if ([
      'Diesel V Power',
      'Diesel V Power Lunes',
      'Diesel V Power Jumbo Prime',
      'Diesel V Power Empleados'
    ].includes(description1)) {
      return '../../../assets/icon/icon-charge-yellow.svg';
    }
  
    if ([
      'Lubricantes Premium Empleados',
      'Lubricantes Empleados',
      'Tienda Select Empleados',
      'Lubricantes Premium',
      'Lubricantes'
    ].includes(description1)) {
      return '../../../assets/icon/icon-lubricant-yellow.svg';
    }
  
    if ([
      'Duplica puntos Tienda',
      'Triplica Puntos Shell Select',
      'Duplica Puntos MODO',
      'Duplica puntos Lubricantes',
      'Duplica puntos Combustible',
      'Duplica puntos Lunes',
      'Promo Duplica puntos Tienda Select',
      'Acumulacion Incentivo Expertos',
      'Acumulación Por Misión Cumplida',
      'Acumulación Somos Protagonistas'
    ].includes(description1)) {
      return '../../../assets/icon/icon-celeb-yellow.svg';
    }
  
    if ([
      'Puntos Regalo Market Shell',
      'Regalo Shell Box',
      'Puntos de Regalo Shell Box',
      'Puntos de Regalo'
    ].includes(description1)) {
      return '../../../assets/icon/icon-gift-yellow.svg';
    }
  
    if ([
      'Devolución Market Shell',
      'Devolución puntos'
    ].includes(description1)) {
      return '../../../assets/icon/icon-devolution.svg';
    }
  
    return '../../../assets/icon/icon-exchange-transfer-red.svg';
  }
  

  formatNumber(amount: number): string {
    return amount?.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }  

  async handleUser(){
    this.currentUser = await this.authService.getCurrentUser();  
    this.userName = `${this.currentUser?.person?.profile?.firstname}${this.currentUser?.person?.profile?.lastname}`;  
  }

  async getSliderBenefits(): Promise<void> {
    try {
      const sliders = await this.sliderService.getSliderBenefits().toPromise();
      this.slidersBenefit = sliders || [];  
    } catch (error) {
      console.error('Error fetching slider benefits:', error);
    }
  }

  async getBenefits() {
    try {
      this.benefits = await this.benefitsService.get().toPromise();
    } catch (error) {
      console.error('Error obteniendo beneficios:', error);
    }
  }

  normalizeText(text: string, movementType?: string): string {
    const lowerCaseText = text.toLowerCase();
    if (lowerCaseText === 'checkout') {
      return 'Conversor';
    } else if (lowerCaseText === 'transferencia de puntos' && movementType === 'Credit') {
      return 'Transferencia recibida';
    } else if (text) {
      return text;
    } else {
      return '';
    }
  }

}
